<script setup>
import LargeRounded from './layouts/LargeRounded.vue'; // Old name: CollectionsSlider
import LargeSquare from './layouts/LargeSquare.vue';
import StoryStyle from './layouts/StoryStyle.vue';

const props = defineProps({
  blockPosition: {
    type: Number,
    default: 0,
  },

  contentSource: {
    type: String,
    default: 'component',
    validate: (value) => ['component', 'sharedContent'].includes(value),
  },
  linksDisplayLayout: {
    type: String,
    default: 'largeRounded',
    validate: (value) => ['largeRounded', 'largeSquare', 'storyStyle'].includes(value),
  },

  heading: {
    type: String,
    default: null,
  },
  links: {
    type: Array,
    default: () => [],
  },

  sharedLinkCollection: {
    type: Object,
    default: () => ({}),
  },
});

const layoutComponent = computed(() => {
  switch (props.linksDisplayLayout) {
    case 'largeRounded':
      return LargeRounded;
    case 'largeSquare':
      return LargeSquare;
    case 'storyStyle':
      return StoryStyle;
    default:
      return LargeRounded; // Fallback to LargeRounded if no match
  }
});

const sourceProperties = computed(() => {
  if (props.contentSource === 'sharedContent') {
    return {
      heading: props.sharedLinkCollection[0]?.heading || null,
      links: props.sharedLinkCollection[0]?.links || [],
    };
  } else {
    return {
      heading: props.heading,
      links: props.links,
    };
  }
});
</script>

<template>
  <component :is="layoutComponent" v-bind="{ ...sourceProperties, blockPosition }" />
</template>
